import React from 'react';

const AnalyticsDashboard = ({ activeTab = 'overview' }) => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>Analytics Dashboard</h1>
      <p>Active Tab: {activeTab}</p>
      <p>Analytics features coming soon...</p>
    </div>
  );
};

export default AnalyticsDashboard;
